/**
 * Landing Page Functionality
 * Handles scroll to products and cart form submission
 */

(function() {
  'use strict';

  // Smooth scroll to products section
  function initScrollToProducts() {
    const scrollButtons = document.querySelectorAll('.scroll-to-products');
    
    scrollButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        const targetId = this.getAttribute('data-scroll-target') || this.getAttribute('href');
        
        if (targetId && targetId.startsWith('#')) {
          e.preventDefault();
          const targetElement = document.querySelector(targetId);
          
          if (targetElement) {
            const headerOffset = 80; // Account for fixed header if any
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }
      });
    });
  }

  // Handle upsell form submission with redirect to checkout
  function initUpsellForm() {
    const upsellForms = document.querySelectorAll('.upsell-form[data-redirect-checkout="true"]');
    
    upsellForms.forEach(upsellForm => {
      upsellForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(this);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || '1';
        
        if (!variantId || typeof variantId !== 'string') {
          console.error('Variant ID is required');
          return;
        }

        // Disable button during submission
        const submitButton = this.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.style.opacity = '0.6';
        }

        // Add to cart via AJAX
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: String(variantId),
            quantity: parseInt(String(quantity), 10)
          })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then(data => {
          // Redirect to checkout
          window.location.href = '/checkout';
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          
          // Re-enable button
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.style.opacity = '1';
          }
          
          // Fallback: try traditional form submission with return_to parameter
          const form = e.target;
          if (!form || !(form instanceof HTMLFormElement)) {
            console.error('Form element not found');
            return;
          }
          
          const action = form.action || '/cart/add';
          const variantIdStr = String(variantId);
          const quantityStr = String(quantity);
          
          // Create a temporary form for fallback
          const tempForm = document.createElement('form');
          tempForm.method = 'post';
          tempForm.action = action;
          
          const idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = 'id';
          idInput.value = variantIdStr;
          tempForm.appendChild(idInput);
          
          const qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'quantity';
          qtyInput.value = quantityStr;
          tempForm.appendChild(qtyInput);
          
          const returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          returnInput.value = '/checkout';
          tempForm.appendChild(returnInput);
          
          document.body.appendChild(tempForm);
          tempForm.submit();
        });
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initScrollToProducts();
      initUpsellForm();
    });
  } else {
    initScrollToProducts();
    initUpsellForm();
  }
})();
